export default "__VITE_ASSET__BahpJ82U__"